/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Energie() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Energie besparen</h1>
          <p>
            Toen wij in 2006 in ons huidige huis gingen wonen, hadden we al snel de wens om ons huis zo energiezuinig mogelijk te maken. Enerzijds door het huis goed te isoleren,
            en zuinig met energie om te gaan. Anderzijds door ook deels zelf energie op te wekken (met zonneboiler en zonnepanelen). We deden dit niet alleen voor het milieu, maar
            ook voor de portemonnee. Destijds heb ik veel onderzoek gedaan naar stroomgebruik en kostenbesparing door de aanschaf van nieuwe apparaten, zonnepanelen zonneboiler.
            Inmiddels zijn we ongeveer 15 jaar verder en was het tijd de website te vernieuwen. Een groot deel van de informatie die ik destijds op de website heb staan heb ik ook
            overgezet naar de nieuwe, omdat deze anno 2024 nog altijd relevant is.
          </p>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h1>Meten is weten (anno 2010)</h1>
          <p>
            In 2010 heb ik een energiemeter aangeschaft en ben ik het verbruik van alle apparaten in huis gaan meten. Dat gaf toen een interessante inzage in het energieverbruik.
            Anno 2024 zal er wel het een en ander veranderd zijn, maar op hoofdlijnen zullen de conclusies van toen nu nog steeds van toepassing zijn.
          </p>
          <p>
            De "Top 5 grootverbruikers" is samengesteld op basis van het verbruik <u>per uur</u> van het apparaat wanneer het in gebruik is. Een wasprogramma duurt meer dan een
            uur, dus het totale verbruik van dat programma is meer. In deze top 5 is dus terug te vinden welke apparaten het meeste energie verbruiken als ze aan staan.
          </p>
          <p>
            In de "Top 5 duurste apparaten" is gekeken naar het totale energieverbruik van het apparaat per jaar, zoals wij er gebruik van maken. Die top 5 is anders omdat een
            koel-vriescombinatie het hele jaar aan staat en de wasmachine gelukkig niet.
          </p>
        </div>
        <div className="right">
          <h2>Top 5 grootverbruikers</h2>
          <ul>
            <li>Magnetron op hoogste stand - 1,55 kWh</li>
            <li>Strijkijzer - 1,17 kWh</li>
            <li>Wasmachine kookwas 95 graden - 0,48 kWh</li>
            <li>Wasmachine 40/60 graden - 0,45 kWh</li>
            <li>Wasmachine 40 graden - 0,39 kWh</li>
          </ul>

          <h2>Top 5 duurste apparaten</h2>
          <ul>
            <li>Koel-vriescombinatie - 711 kWh - 183,01 euro</li>
            <li>Router - 105 kWh - 27,03 euro</li>
            <li>Wasmachine - 101 kWh - 23,67 euro</li>
            <li>HUB - 88 kWh - 22,52 euro</li>
            <li>PC randapparatuur (uit) - 88 kWh - 22,52 euro</li>
          </ul>
        </div>
      </div>
      <div className="box light">
        <div className="row">
          <h1>Conclusies</h1>
          <p>
            Uit de lijst is op te maken dat elektrisch verwarmen veel energie kost. Maar wat ook zeer opvallend is, is dat onze router per jaar meer energie kost dan de wasmachine,
            omdat die nu eenmaal altijd aan staat. Destijds is de router op basis van deze metingen dan ook vervangen. De koel-vriescombinatie ook overigens, bij het vervangen van
            de gehele keuken.
          </p>
          <p>Wat ook opviel was dat de TV buiten de top 5 viel. Een TV gebruikt niet heel veel stroom</p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h1>Tips</h1>
          <p>
            Na jarenlang meten onder het mom van 'meten is weten' kwam ik tot de onderstaande lijst van bespaartips. Een aantal tips heb ik bijgewerkt naar het jaar 2024, zoals de
            tip om gloeilampen te vervangen door spaarlampen:
          </p>
          <ul>
            <li>
              Schaf een energiemeter aan en meet wat je apparaten verbruiken, want meten is weten! Met name het sluipverbruik kan interessant zijn. Soms verbruiken apparaten die
              helemaal uit staan nog steeds significant veel stroom, zoals de randapparatuur van onze PC. Een stand-by stopper kan zich binnen een jaar terugverdienen.
            </li>
            <li>
              Vervang oude apparatuur door nieuwe. Oude apparaten verbruiken duidelijk meer energie dan nieuwe dus het is weer een kwestie van tijd dat je deze aanschaf
              terugverdiend. Natuurlijk moet je bij die aanschaf wel letten op het energielabel. In ons geval scheelt het vervangen van de koelkast ruim 100 euro per jaar aan
              energie.
            </li>
            <li>
              Koop spaarlampen, of nog beter, LED lampen. Een inkoppertje, maar gloeilampen verbruiken inderdaad significant meer stroom dan spaarlampen en de aanschaf heb je er
              dan ook al snel uit.
            </li>
            <li>
              Schaf zonnepanelen aan. Die van ons zijn al lang en breed terugverdiend. De prijs van de zonnepanelen is de afgelopen jaren sterk gedaald. Ondanks het feite dat je
              tegenwoordig een terugleververgoeding betaald over de stroom die je teruglevert aan het net (omdat de salderingsregel nog even blijft bestaan), zijn de panelen nog
              steeds rendabel.
            </li>
            <li>
              Dat je met in het weekend i.p.v. overdag wassen geld kunt besparen is een broodje aap verhaal. OK, het scheelt. Maar het verschil is in ons geval nog geen 5 euro per
              jaar.
            </li>
            <li>Apparaten die elektrisch verwarmen verbruiken het meeste energie. Dit zijn dus de magnetron, strijkijzer en wasmachine.</li>
            <li>
              Het "sluipverbruik" van apparaten in stand-by modus blijkt nogal verschillend te zijn per apparaat. Bij het ene apparaat (zoals onze TV) is het verbruik in stand-by
              mode niet eens meetbaar, bij een ander apparaat wat helemaal uit lijkt te staan wordt er toch een paar Watt per uur verbruikt. Alles bij elkaar optellend gaat het dan
              al snel hard. Zo is dat voor onze PC met randapparatuur op jaarbasis 170 kWh (40 euro)! Een stand-by stopper kan dus al heel snel terugverdiend zijn.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Energie;
